import moment from "moment-timezone";
import {range} from "lodash";
import {
  getDateOfBirth
} from "../redux/modules/PersonalInformation/personalInformation.selectors";
import {useSelector} from "react-redux";

export const calculateAndFormatUnixDates = (
  timestamp,
  format = "MM/DD/YYYY"
) => {
  const d = moment(timestamp);
  return d.tz("America/New_York").format(format);
};

export const futureDate = (timestamp, addValue) => {
  return moment(timestamp).add(addValue, "day");
};

export const getDisabledDays = (monthArr) => {
  let arr = [...defaultIdsabledDays];
  if (monthArr) {
    for (let i = 0; i < monthArr.length; i++) {
      let curr = monthArr[i].label;
      const isCurrentMonth = new Date().getMonth() === monthArr[i].value;
      if (isCurrentMonth) {
        arr = arr.concat(lastDays);
      }
      if (curr === "JAN") {
        arr = arr.concat([1, 2, 3, 4, 5]);
      } else if (curr === "FEB") {
        arr = arr.concat([29, 30, 31]);
      } else if (
        curr === "APR" ||
        curr === "JUN" ||
        curr === "SEP" ||
        curr === "NOV"
      ) {
        arr.push(31);
      } else if (curr === "DEC") {
        arr = arr.concat([25, 26, 27, 28, 29, 30, 31]);
      }
    }
  }

  return arr;
};

const defaultIdsabledDays = [1, 2, 3, 4, 5];
const lastDays = range(new Date().getDate(), new Date().getDate() + 5, 1);

export const isDisabledDay = (month, day, monthVal) => {
  const isCurrentMonth = new Date().getMonth() === monthVal;
  if (defaultIdsabledDays.includes(day) || (lastDays.includes(day) &&isCurrentMonth)) {
    return true;
  }

  switch (month) {
    case "JAN":
      return [1, 2, 3, 4, 5].includes(day);
    case "FEB":
      return [29, 30, 31].includes(day);
    case "DEC":
      return [25, 26, 27, 28, 29, 30, 31].includes(day);
    case "APR":
    case "JUN":
    case "SEP":
    case "NOV":
      return day === 31;
    default:
      return false;
  }
};

export const getHeaderDisabledText = (monthArr) => {
  if (monthArr) {
    let janFlag = false,
      decFlag = false;

    for (let i = 0; i < monthArr.length; i++) {
      if (monthArr[i].label === "JAN") {
        janFlag = true;
      } else if (monthArr[i].label === "DEC") {
        decFlag = true;
      }
    }
    if (janFlag && !decFlag) {
      return "have restricted dates.";
    } else if (!janFlag && decFlag) {
      return "have restricted dates.";
    } else if (janFlag && decFlag) {
      return "have restricted dates.";
    }
  }
  return "have restricted dates.";
};

export const isValidSelection = (months, day) => {
  if (months && day) return months.length > 0 && day.length !== 0;
  return false;
};

export const futureYear = (addValue, format) => {
  return moment().add(addValue, 'year').format(format);
};

export const getCurrentDate = () => {
  const d = moment();
  return d.tz('America/New_York');
};

export const currentYear = (format) => {
  return getCurrentDate().format(format);
};

/** This function formats the Unix Date to display with the month name
 * e.g: 2023-12-29T23:59:59.999+0.00 and returns December 29, 2023
 * @param {string} value
 * @return date
 */
 export const formatUnixDate = (value) => {
  const monthNames = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  const d = new Date(value);
  const month = monthNames[d.getMonth()];
  const day = d.getDate()
  const year = d.getFullYear()
  return `${month} ${day}, ${year}`;
};


export const yearUserTurningRMDEligible = () => {
    const dateOfBirth = useSelector(getDateOfBirth);
    const dateAtUserTurnsRMDEligible = moment(dateOfBirth).add(
      73,
      'years'
    );
  return moment(dateAtUserTurnsRMDEligible).utc().format('YYYY');
};

export const userTurnsRMDEligible = (dob) => {
  const dateAtUserTurnsRMDEligible = moment(dob).add(
    73,
    'years'
  );
  return moment(dateAtUserTurnsRMDEligible).utc().format('YYYY');
};